import moment from 'moment';

// Table cols for Assemblies and Parts Table
export default {
	defaultSortField: 'name',
	defaultSortOrder: 'asc',
	rearrangeCols: false,
	isCheckable: false,
	// stickeyHeaders: true,
	gutterOpts: {
		buttons: [
			// {
			//   event: 'columnChooser',
			//   icon: 'icon-tablecolumns',
			//   tooltip: 'Customize Columns',
			//   isLine: true,
			// }
		],
	},
	toolBar: {
		buttons: [
			{  
                label: 'History',
                event: 'activity',
                icon: 'icon-activityhistory',
            },
			{
				event: "addNew",
				icon: "icon-addnew",
				isLine: true,
				tooltip: "Add New",
				permissionModule: 'app&projects',
				alterDataKey: 'alterProject',
			},
		],
		bulkActions: () => { },
	},
	fields: [
		{
			title: 'Name',
			name: 'name',
			width: '400px',
			id: 'name',
			sortField: 'firstName',
			prop: 'fullName',
			defaultVisible: true,
		},
		{
			title: 'Email',
			name: 'email',
			width: '400px',
			id: 'email',
			prop: 'email',
			sortField: 'email',
			defaultVisible: true,
		},
		{
			name: 'admin',
			width: '152px',
			title: 'Admin',
			id: 'isAdmin',
			prop: 'isAdmin',
			defaultVisible: true,
		},
		{
			name: 'role',
			width: '192px',
			title: 'Role',
			id: 'memberRole',
			sortField: 'role',
			prop: 'memberRole',
			defaultVisible: true,
			formatter: (val) => {
				const mapper = {
					'shop-super': 'Shop Super',
					'shipping-manager': 'Shipping Manager',
					'project-executive': 'Project Executive',
					'project-manager': 'Project Manager',
					'project-engineer': 'Project Engineer',
					'procurement-manager': 'Procurement Manager',
					'partner': 'Partner',
					'inventory-manager': 'Inventory Manager',
					'field-super': 'Field Super',
					'estimator': 'Estimator',
					'detailer': 'Detailer',
					'coordinator': 'Coordinator',
					'assistant-project-manager': 'Assistant Project Manager'
				}
				return mapper[val]
			}
		},
		{
			name: 'officePhone',
			sortField: 'officePhone',
			width: '192px',
			title: 'Office',
			id: 'officePhone',
			prop: 'officePhone',
			defaultVisible: true,
		},
		{
			name: 'mobilePhone',
			sortField: 'mobilePhone',
			width: '192px',
			title: 'Mobile',
			id: 'mobilePhone',
			prop: 'mobilePhone',
			defaultVisible: true,
		},
		{
			name: 'activated',
			width: '192px',
			sortField: 'activated',
			title: 'Status',
			id: 'status',
			defaultVisible: true,
			prop: 'activated',
			formatter(val) {
				return val ? 'Active' : 'Inactive'
			},
		},
		{
			title: 'Actions',
			name: 'table-field-actions',
			id: 'action',
			hideFromChooser: true,
			alwaysVisible: false,
			defaultVisible: true,
			width: '112px',
			// sticky: true,
			// clearBtn: true,
			// searchable: true,
			// hideAllFilters: false,
			permissionModule: 'app&projects',
			permissionKey: 'assembly_parts',
			// thAttrs: () => ({ class: 'action-sticky' }),
			// tdClass: 'action-sticky',
			inputProps: {
				showEdit: true,
				groupButtons() {
					return [
						{
							icon: "icon-edit",
							event: "edit",
							tooltip: "Edit",
							permissionModule: 'app&projects',
							alterDataKey: 'alterProject',
						},
						{
							icon: "icon-bin",
							event: "delete",
							tooltip: "delete",
							disabled(row) {
								return row.canDelete;
							},
							permissionModule: 'app&projects',
							alterDataKey: 'alterProject',
						},
					];
				},
			},
		},
	],
};
